import { unlockScroll } from './util/common';
import { newModalFromString } from './components/modal';

document.addEventListener('DOMContentLoaded', () => {
    GetColourMenuItem();
    AddMobileLegalAreaItem();

    function GetColourMenuItem () {
        const $selectedLegalPage = $('.js-recognize-page-legal');
        if ($selectedLegalPage.hasClass('js-legal-privacy-page')) {
            $('.legal-area-menu li.privacy-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-legal-cookie-page')) {
            $('.legal-area-menu li.cookie-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-legal-use-page')) {
            $('.legal-area-menu li.use-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-legal-sales-page')) {
            $('.legal-area-menu li.sales-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-legal-reviews-page')) {
            $('.legal-area-menu li.reviews-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-legal-event-page')) {
            $('.legal-area-menu li.event-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-legal-impressum')) {
            $('.legal-area-menu li.impressum-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-corporate-page')) {
            $('.legal-area-menu li.corporate-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-franchising-page')) {
            $('.legal-area-menu li.franchising-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-accessibility-page')) {
            $('.legal-area-menu li.accessibility-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-faq-page')) {
            $('.legal-area-menu  li.faq-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-orders-page')) {
            $('.legal-area-menu  li.orders-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-shipping-page')) {
            $('.legal-area-menu  li.shipping-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-returns-page')) {
            $('.legal-area-menu  li.returns-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-payments-page')) {
            $('.legal-area-menu  li.payments-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-gift-page')) {
            $('.legal-area-menu  li.gift-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-loyalty-page')) {
            $('.legal-area-menu  li.loyalty-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-account-page')) {
            $('.legal-area-menu  li.account-item').addClass('background-active-item');
        } else if ($selectedLegalPage.hasClass('js-stores-page')) {
            $('.legal-area-menu  li.stores-item').addClass('background-active-item');
        }
    }

    function AddMobileLegalAreaItem () {
        const $mobileItemBox = $('.mobile-only-legal-area-menu-item');
        const itemCode = $('.js-legal-mobile-page').html();
        $mobileItemBox.html(itemCode);
        $mobileItemBox.removeClass('hide');
    }

    $(document).on('click', '.js-tabsWrp .js-tabBtn', function () {
        var tabId = $(this).attr('data-tab');
        $('.js-tabBtn.cc-active').removeClass('cc-active');
        $('.cc-tabsContent.cc-active').removeClass('cc-active');
        $(this).addClass('cc-active');
        $('#' + tabId).addClass('cc-active');
    });

    $('.print-page').on('click', function () {
        window.print();
    });

    $('body').on('click', '.js-customerCareReturnModalTrigger', function (e) {
        if ($('.cc-customerCareReturnModal').length === 0) {
            e.preventDefault();
            const htmlContent = $('.js-modal-customer-care-return').html();
            var modalContent = $('.js-customerCareReturnModalContent').html();

            const onPopupClose = () => {
                unlockScroll();
            };
            if ($('.cc-customerCareReturnModal').length > 0) {
                return;
            }

            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['cc-customerCareReturnModal'], null, onPopupClose);
            $('.tingle-modal-box').addClass('rightModalAttribute');
            modal.open();
            modal.setContent(modalContent);
            $(modal.modalBox)
                .find('.close-button-modal')
                .on('click', function (e) {
                    modal.close();
                });
        }
    });

    const myInformationTabs = document.querySelector('.js-franchising-page #example-tabs');
    if (myInformationTabs) {
        myInformationTabs.onscroll = (e) => {
            if (myInformationTabs.scrollLeft + myInformationTabs.offsetWidth >= myInformationTabs.scrollWidth) {
                document.documentElement.style.setProperty('--gradientScroll', 'linear-gradient(271deg, $white 1.21%, rgba(255, 255, 255, 0) 72.94%)');
            } else {
                document.documentElement.style.setProperty('--gradientScroll', 'unset');
            }
        };
    }
});
